
const companyLogos = [
  { src: "/lovable-uploads/Shiprocket.png", alt: "Shiprocket" },
  { src: "/lovable-uploads/BitsInGlass.png", alt: "Bits In Glass" },
  { src: "/lovable-uploads/SunKing.png", alt: "Sun King" },
];

import OptimizedImage from '@/components/ui/optimized-image';

const CompaniesTicker = () => {
  return (
    <div className="mt-16">
      <h3 className="text-xl text-cs-medium-grey text-center mb-8">
        Companies that have made multiple offers
      </h3>
      
      <div className="relative overflow-hidden">
        <div className="flex animate-infinite-scroll space-x-8 py-4">
          {[...companyLogos, ...companyLogos].map((logo, index) => (
            <OptimizedImage
              key={index}
              src={logo.src}
              alt={logo.alt}
              className="h-12 w-auto grayscale hover:grayscale-0 transition-all"
              width={120}
              height={48}
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompaniesTicker;
